<template>
  <div class="screen">
    <div class="top">
      <div @click="onBack" class="back">
        <i class="el-icon-back"></i> 返回
      </div>

      <div v-if="monitorData" class="info">
        {{monitorData && monitorData.teacherName ? monitorData.teacherName : monitorData.monitorCode}}，你好
      </div>

      <div @click="onLogout" class="logout">
        退出登录
      </div>
    </div>
    <div v-if="show" class="content">
      <div @click="toLive" class="content-item">
        <img class="ci-img" src="../assets/screen.png" alt="">
        <div>进入监考室</div>
      </div>
      <div @click="toDataView" class="content-item">
        <img class="ci-img" src="../assets/dataview.png" alt="">
        <div>查看考试统计</div>
      </div>
    </div>
    <SelectData :visible.sync="visible" @getStatisticId="getStatisticId"></SelectData>
  </div>
</template>

<script>
import SelectData from './components/select-data.vue';
export default {
  name: 'screen',
  components: {SelectData},
  data() {
    return {
      show: true,
      monitorData: null,
      roomData: null,
      visible: false
    }
  },
  mounted() {
    this.monitorData = this._storage.getStorageSync('monitorData')
    this.roomData = this._storage.getStorageSync('roomData')
    setTimeout(() => {
      this.show = true
    }, 300)
  },
  methods: {
    onLogout() {
      this.$confirm('是否确认退出登录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this._storage.removeStorageSync('collegeId')
        this._storage.removeStorageSync('userInfo')
        this._storage.removeStorageSync('monitorData')
        this.$router.replace('/')
      }).catch(() => {

      });
    },
    onBack() {
      this.$router.back()
    },
    toLive() {
      this.$router.push('/main')
    },
    toDataView() {
      this.visible = true
    },
    getStatisticId(val) {
      console.log(val)
      this.$router.push('/data-view')
    }
  }
}
</script>

<style lang="scss" scoped>
.screen {
  width: 100%;
  height: 100%;
}
.top {
  color: #fff;
  display: flex;
  align-items: center;
  height: 60px;
  padding: 0 20px;
  // background: rgba($color: #04070F, $alpha: 0.32);
  background: #2e2c8a;

  .info {
    margin-left: 20px;
  }

  .logout {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    cursor: pointer;
    width: 120px;
    height: 32px;
    border: 1px solid #FFFFFF;
    border-radius: 16px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    color: #FFFFFF;
  }
  .back {
    cursor: pointer;
    border: 1px solid #FFFFFF;
    border-radius: 16px;
    font-size: 14px;
    padding: 5px 15px;
  }
}
.content {
  width: 100%;
  height: calc(100% - 60px);
  background: #0a084d;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-item {
  width: 400px;
  height: 200px;
  background-color: rgba(46, 44, 138, 1);
  box-sizing: border-box;
  border: 1px solid rgba(45, 140, 240, 1);
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgb(22 23 30);
  font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 24px;
  color: #FFF;
  margin: 0 20px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.ci-img {
  width: 75px;
  height: 75px;
  margin-bottom: 15px;
}
</style>
